import { types } from 'mobx-state-tree'

const DealerStore = types
  .model('DealerStore', {
    dealers: types.maybeNull(types.frozen())
  })
  .actions(self => ({
    setDealers(dealers) {
      self.dealers = dealers
    }
  }))

export default DealerStore.create()
